import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { useGlobalContext } from '../data/GlobalContext';
import { usePromotionsData } from '../data/PromotionData';
import CountdownTimer from '../data/CountdownTimer';
import Deposit from '../transactions/Deposit';
import RollingCommission from '../promotions/RollingCommission';
import ModuleFaChaiGrandSpinAle from '../promotions/promotion_modules/modules_fcGrandSpinAle';
import ModulesLotteryDraw from '../promotions/promotion_modules/modules_lotterDraw';
import ModulesPeraBayong from '../promotions/promotion_modules/modules_peraBayong';
import LoginToPlay from '../data/LoginToPlay';
import ModuleJiliGrandSlot from '../promotions/promotion_modules/ModuleJiliGrandSlot';
import ModuleEvoThrone from '../promotions/promotion_modules/ModuleEvoThrone';
import CandyLoadingPage from './games/CandyLoadingPage';
import JiliRushGame from './games/JiliRushGame';

export default function FeaturedPromoMobile() {
    const [isFeaturedPromoOpen, setIsFeaturedPromoOpen] = useState(true);
    const [isFeaturedPromoPop, setIsFeaturedPromoPop] = useState(false);
    const { setShowEasterEgg, showMysteryFridayBtn, doubleUpTurnover } =
        useGlobalContext();
    const [isShowViewEntry, setIsShowViewEntry] = useState(false);
    const [showRolling, setShowRolling] = useState(false);
    const [showJiliRush, setShowJiliRush] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [activeModal, setActiveModal] = useState(null);
    const [isShowDoubleUp, setIsShowDoubleUp] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [login, setLogin] = useState(false);
    const [isDepositOpen, setIsDepositOpen] = useState(false);
    const [now, setNow] = useState(() => new Date());
    const { promotionsData } = usePromotionsData();

    useEffect(() => {
        const interval = setInterval(() => {
            setNow(new Date());
        }, 60 * 1000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        setIsLoggedIn(localStorage.getItem('isLoggedIn') === 'true');
    }, []);

    useEffect(() => {
        document.body.style.overflow = isFeaturedPromoPop ? 'hidden' : 'auto';
        return () => (document.body.style.overflow = 'auto');
    }, [isFeaturedPromoPop]);

    const getPaydayWindowPH = useCallback((date = new Date()) => {
        const formatter = new Intl.DateTimeFormat('en-CA', {
            timeZone: 'Asia/Manila',
            year: 'numeric',
            month: '2-digit',
        });

        const parts = formatter.formatToParts(date);

        const year = parts.find((part) => part.type === 'year').value;
        const month = parts.find((part) => part.type === 'month').value;

        return {
            startDate: `${year}-${month}-15T12:00:00+08:00`,
            endDate: `${year}-${month}-18T12:00:00+08:00`,
        };
    }, []);

    const isPaydayPromoActivePH = useCallback(
        (date = new Date()) => {
            const { startDate, endDate } = getPaydayWindowPH(date);

            const nowTime = date.getTime();
            const startTime = new Date(startDate).getTime();
            const endTime = new Date(endDate).getTime();

            return nowTime >= startTime && nowTime < endTime;
        },
        [getPaydayWindowPH]
    );

    const handlePromoPop = () => {
        setIsFeaturedPromoOpen(false);
        setIsFeaturedPromoPop(true);
    };

    const handleClosePop = () => {
        setIsFeaturedPromoOpen(true);
        setIsFeaturedPromoPop(false);
    };

    const featuredPromotions = useMemo(() => {
        return promotionsData
            .filter((promotion) => promotion.featuredPromotion)
            .sort((a, b) => (a.priority ?? 999) - (b.priority ?? 999));
    }, [promotionsData]);

    const nextPromotion = useMemo(() => {
        const paydayPromotion = promotionsData.find(
            (promotion) => promotion.title === 'Payday Bonus'
        );

        if (paydayPromotion && isPaydayPromoActivePH(now)) {
            const { startDate, endDate } = getPaydayWindowPH(now);

            return {
                ...paydayPromotion,
                startDate,
                endDate,
            };
        }

        const featuredPromo = promotionsData.find(
            (promotion) => promotion.isShowOnFeatured
        );

        if (featuredPromo) {
            return featuredPromo;
        }

        const dayMap = { thursdayPromotion: 4, fridayPromotion: 5 };
        const currentDay = now.getDay();

        const filtered = promotionsData.filter(
            (p) =>
                p.highlightPromotion &&
                (p.thursdayPromotion || p.fridayPromotion)
        );

        const sorted = filtered
            .map((p) => {
                const day =
                    dayMap[
                        p.thursdayPromotion
                            ? 'thursdayPromotion'
                            : 'fridayPromotion'
                    ];

                let diff = day - currentDay;
                if (diff <= 0) diff += 7;

                return { ...p, diff };
            })
            .sort((a, b) => a.diff - b.diff);

        return sorted[0];
    }, [promotionsData, now, getPaydayWindowPH, isPaydayPromoActivePH]);

    const modalComponents = {
        '2/30 Lottery Draw': ModulesLotteryDraw,
        'Pera O Bayong': ModulesPeraBayong,
        'FC Grand Spin-Ale': ModuleFaChaiGrandSpinAle,
        'Jili Grand Slot': ModuleJiliGrandSlot,
        'Evo Throne': ModuleEvoThrone,
    };

    const ActiveModal = activeModal ? modalComponents[activeModal] : null;

    const requireLogin = (callback) => {
        if (isLoggedIn) callback();
        else setLogin(true);
    };

    const hiddenTitlesForPlayNow = [
        'Pera O Bayong',
        'Exclusive Rolling Commission',
        '2/30 Lottery Draw',
        "8's Your Lucky Draw",
        'CQ9 Funalo',
        'Fortune Drops 2026',
        'JDB Spin Tournament',
        'CQ9 King of Betting',
        'Race of Reels: Slots Tournament',
        'BNG Splash Spin Into Summer',
        'BNG Prize Drop',
        'Gates of Olympus Roulette',
        'Jelly Express Daily Tournament',
        'Sweet Bonanza 2500',
        'Road to Glory',
        'Candy Rush Wheel Drops',
        'BNG World Cup Fortune Race',
        'Grand Baccarat Kick-Off',
        'World Cup Champ Rush',
        "JDB's Winners League",
        'Jili Quest',
        'VP Cash & Card',
        'Rise Of Heroes',
        'Color Game Bonanza',
        'Fastspin Frostfire Clash',
        'Race to Fame',
        'Jili Fortune Rush',
        'Vertex Play',
        'Play With Kevin',
    ];

    const hiddenTitlesForJili = [
        ...hiddenTitlesForPlayNow,
        'Pragmatic Play Daily',
        'Recovery Bonus',
        'Flexi-Spin Showdown',
        '8PM Recovery Hour',
        'CQ9 Funalo',
        'TPGreat Spins of Fortune',
        'JDB Spin Tournament',
        'PGSoft Global Cash',
        'Fast Cashout Guarantee',
        'Jili Grand Slot',
        'World Cup Weekly Lottery',
        'Rain Of Wins',
        'Fury Of Anubis',
        'Evo Throne',
        'Play With Kevin',
    ];

    const handlePromoAction = (title) => {
        const actions = {
            'Easter Egg Drop': () => setShowEasterEgg(true),

            'Exclusive Rolling Commission': () =>
                requireLogin(() => setShowRolling(!showRolling)),

            'Jili Fortune Rush': () =>
                requireLogin(() => setShowJiliRush(!showJiliRush)),

            '2/30 Lottery Draw': () =>
                requireLogin(() => setActiveModal(title)),

            'Flexi-Spin Showdown': () =>
                requireLogin(() => setActiveModal(title)),

            'CQ9 Funalo': () => requireLogin(() => setActiveModal(title)),

            "JDB's Winners League": () =>
                requireLogin(() => setActiveModal(title)),

            'FGH RECOVERY BONUS is back!': () =>
                requireLogin(() => setIsDepositOpen(true)),

            '8PM Recovery Hour': () =>
                requireLogin(() => setIsDepositOpen(true)),

            'Pera O Bayong': () => setActiveModal(title),

            'JDB Exclusive Promo': () => setActiveModal(title),

            'Race of Reels: Slots Tournament': () =>
                requireLogin(() => setActiveModal(title)),

            'Fortune Drops 2026': () =>
                (window.location.href = '/promotion/fortune-drops'),

            'JDB Spin Tournament': () =>
                requireLogin(() => setActiveModal(title)),

            'Pragmatic Play Daily': () =>
                (window.location.href = '/slots/?provider=PP'),

            'TPGreat Spins of Fortune': () =>
                (window.location.href =
                    '/promotion/tpg-great-spins-of-fortune'),

            'Pragmatic Play Zombie School': () =>
                (window.location.href = '/slots/?provider=PP'),

            'BNG Splash Spin Into Summer': () =>
                requireLogin(() => setActiveModal(title)),

            'Jili Grand Slot': () => requireLogin(() => setActiveModal(title)),

            'Rain Of Wins': () => requireLogin(() => setActiveModal(title)),

            'PGSoft Global Cash': () =>
                (window.location.href = '/promotion/pg-global-cash'),

            'BNG Prize Drop': () =>
                (window.location.href = '/promotion/bng-prize-drop'),

            'Sweet Bonanza 2500': () =>
                (window.location.href = '/promotion/pragmatic-play-daily'),

            'Jelly Express Daily Tournament': () =>
                (window.location.href = '/promotion/jelly-express'),

            'Gates of Olympus Roulette': () =>
                (window.location.href = '/promotion/gates-of-olympus'),

            "8's Your Lucky Draw": () =>
                requireLogin(() => setIsShowViewEntry(true)),

            'CQ9 King of Betting': () =>
                (window.location.href =
                    'https://betking.jiamengweiquan.com/newyearph'),

            'Candy Rush Wheel Drops': () =>
                (window.location.href =
                    'https://pp88.asia/tl/candy-rush-wheel-drops/'),

            'BNG World Cup Fortune Race': () =>
                (window.location.href =
                    'https://servicebooongo.com//bngevent/event?event=2026worldcup&lang=en&currency=PHP'),

            'Road to Glory': () =>
                (window.location.href = '/promotion/road-to-glory'),
            'Grand Baccarat Kick-Off': () =>
                (window.location.href = '/promotion/grand-baccarat'),
            'Fast Cashout Guarantee': () =>
                (window.location.href = '/promotion/fash-cashout-guarantee'),
            'World Cup Weekly Lottery': () =>
                (window.location.href = '/promotion/world-cup-weekly-lottery'),
            'World Cup Champ Rush': () =>
                (window.location.href = '/promotion/world-cup-champ-rush'),
            'Fury Of Anubis': () =>
                (window.location.href = '/promotion/fury-of-anubis'),
            'Jili Quest': () =>
                (window.location.href = '/promotion/jili-quest'),
            'VP Cash & Card': () =>
                (window.location.href = '/promotion/cash-and-card'),
            'Vertex Play': () =>
                (window.location.href = '/promotion/vertex-play'),
            'Play With Kevin': () =>
                (window.location.href = '/promotion/pragmatic-play'),
            'Fastspin Frostfire Clash': () =>
                (window.location.href = '/promotion/fastspin-frostfire-clash'),
            'Rise Of Heroes': () =>
                (window.location.href = '/promotion/rise-of-heroes'),
            'Color Game Bonanza': () =>
                (window.location.href = '/promotion/color-game-bonanza'),
            'Race to Fame': () =>
                (window.location.href = '/promotion/race-to-fame'),
            'Evo Throne': () => requireLogin(() => setActiveModal(title)),
        };

        return actions[title]
            ? actions[title]()
            : (window.location.href = '/slots/?provider=JILI');
    };

    return (
        <>
            {login && <LoginToPlay onClose={() => setLogin(false)} />}
            {ActiveModal && (
                <ActiveModal closeModal={() => setActiveModal(null)} />
            )}
            {showRolling && (
                <RollingCommission onClose={() => setShowRolling(false)} />
            )}

            <div className="featured-promotion-container">
                {/* MAIN BANNER BUTTON */}
                {isFeaturedPromoOpen && nextPromotion && (
                    <div
                        className="featured-promotion-btn"
                        onClick={handlePromoPop}
                    >
                        <div className="featured-promotion-btn-content">
                            <img
                                src={nextPromotion.imgIcon}
                                alt={nextPromotion.title}
                            />
                            <div>
                                <strong className="featured-promotion-popup-text">
                                    {nextPromotion.title}
                                </strong>
                                <p className="featured-promotion-sub-text">
                                    {nextPromotion.subHeading}
                                </p>
                            </div>
                        </div>
                        <CountdownTimer {...nextPromotion} />
                    </div>
                )}

                {/* POPUP CONTENT */}
                {isFeaturedPromoPop && (
                    <div className="featured-promo-pop-container">
                        {featuredPromotions.map((promotion) => {
                            if (
                                promotion.title === 'Pera O Bayong' &&
                                !showMysteryFridayBtn
                            )
                                return null;

                            const hidePlayNow = hiddenTitlesForPlayNow.includes(
                                promotion.title
                            );
                            const hideJili = hiddenTitlesForJili.includes(
                                promotion.title
                            );

                            return (
                                <div
                                    key={promotion.id}
                                    className="featured-promo-pop-items"
                                >
                                    <img
                                        src={promotion.highlightImgSrc}
                                        alt={promotion.title}
                                        className="featured-promo-pop-img"
                                    />

                                    <div className="featured-promo-pop-details">
                                        <div>
                                            <strong>{promotion.title}</strong>
                                            <p>
                                                {promotion.userQualification}
                                                <span className="promotion-user-rewards">
                                                    {promotion.userRewards}
                                                </span>
                                            </p>
                                        </div>

                                        {/* Play Now (Double Up Eligible) */}
                                        {doubleUpTurnover >= 100000
                                            ? !hidePlayNow && (
                                                  <button
                                                      className="featured-promo-pop-btn"
                                                      onClick={() => {
                                                          setIsShowDoubleUp(
                                                              false
                                                          );
                                                          setTimeout(
                                                              () =>
                                                                  setIsShowDoubleUp(
                                                                      true
                                                                  ),
                                                              0
                                                          );
                                                      }}
                                                  >
                                                      Play Now
                                                  </button>
                                              )
                                            : !hideJili && (
                                                  <a
                                                      className="featured-promo-pop-btn"
                                                      href="/slots/?provider=JILI"
                                                  >
                                                      Play Now
                                                  </a>
                                              )}

                                        {/* Custom Action Button */}
                                        {promotion.title !== 'Double Up' &&
                                            promotion.title !==
                                                'FGH Sign-Up Treat' && (
                                                <button
                                                    className="featured-promo-pop-btn"
                                                    onClick={() =>
                                                        handlePromoAction(
                                                            promotion.title
                                                        )
                                                    }
                                                >
                                                    {promotion.title ===
                                                    'Jili Quest'
                                                        ? 'Full T&C'
                                                        : promotion.btnTxt}
                                                </button>
                                            )}
                                    </div>
                                </div>
                            );
                        })}

                        <p
                            onClick={handleClosePop}
                            className="featured-promo-close-btn"
                        >
                            close
                        </p>
                    </div>
                )}

                {/* DEPOSIT MODAL */}
                {isDepositOpen &&
                    createPortal(
                        <div className="modal-portal">
                            <Deposit
                                onClose={() => setIsDepositOpen(false)}
                                defaultBonusName="New Member Package Bonus"
                            />
                        </div>,
                        document.body
                    )}
                {showJiliRush &&
                    createPortal(
                        isLoading ? (
                            <CandyLoadingPage
                                onLoadingComplete={() => setIsLoading(false)}
                            />
                        ) : (
                            <JiliRushGame
                                onClose={() => setShowJiliRush(false)}
                            />
                        ),
                        document.body
                    )}
            </div>
        </>
    );
}
